import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./HomePage.scss";
import Copyright from "../../components/Copyright/Copyright";
import businesswoman1 from "../../assets/images/businesswoman1.png";
import fcAuthenticationAndSigning from "../../assets/images/fc-authentication-and-signing.png";
import fcBankIntegration from "../../assets/images/fc-bank-integration.png";
import fcAutomaticBankReconciliation from "../../assets/images/fc-automatic-bank-reconciliation.png";
import fcIncomingInvoiceProcessing from "../../assets/images/fc-incoming-invoice-processing.png";
import fcElectronicInvoicing from "../../assets/images/fc-electronic-invoicing.png";
import fcScheduledTasks from "../../assets/images/fc-scheduled-tasks.png";
import fcMultiCompanySupport from "../../assets/images/fc-multi-company-support.png";
import fcERPAndCRMIntegration from "../../assets/images/fc-erp-and-crm-integration.png";
import fcEuro from "../../assets/images/fc-euro.png";
import fcCustomizable from "../../assets/images/fc-customizable.png";
import fcUserRightsManagement from "../../assets/images/fc-user-rights-management.png";
import fcPhoneSupportAndMaintenance from "../../assets/images/fc-phone-support-and-maintenance.png";

const HomePage = () => {
	useEffect(() => {
		// Scroll to top when component mounts
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="home-page">
			{/* Hero Section */}
			<section className="hero-section">
				<div className="hero-container">
					<div className="hero-content">
						<h1 className="hero-title">
							CashManager<br />by D.Vision
						</h1>
						<p className="hero-subtitle">
							A comprehensive financial management solution.
						</p>
						<div className="hero-buttons">
							<Link to="/onboarding" className="btn btn-primary">Get started</Link>
							<button className="btn btn-secondary" onClick={() => document.getElementById('features').scrollIntoView({ behavior: 'smooth' })}>Learn more</button>
						</div>
					</div>
					<div className="hero-image">
						<img src={businesswoman1} />
					</div>
				</div>
			</section>

			{/* Features Section */}
			<section className="features-section" id="features">
				<div className="container">
					<div className="section-header">
						<h2>Why choose CashManager?</h2>
					</div>

					<div className="features-grid">
						{/* <div className="feature-card">
							<div className="feature-icon">💳</div>
							<h3>Payment Management</h3>
							<p>Streamline your payment processes with our advanced payment management system.</p>
						</div> */}

						<Link to="/bank-integration" className="feature-card feature-card-link">
							<div className="feature-icon">
								<img src={fcBankIntegration} />
							</div>
							<h3>Bank integration</h3>
							<p>Native support of Host-2-Host, Gateway and similar services for secure payment flow and statement processing.</p>
						</Link>

						<Link to="/automatic-bank-reconciliation" className="feature-card feature-card-link">
							<div className="feature-icon">
								<img src={fcAutomaticBankReconciliation} />
							</div>
							<h3>Automatic bank reconciliation</h3>
							<p>Customizable criterion-based approach to allocate transactions with maximum precision.</p>
						</Link>

						<Link to="/electronic-invoicing" className="feature-card feature-card-link">
							<div className="feature-icon">
								<img src={fcElectronicInvoicing} />
							</div>
							<h3>Electronic invoicing</h3>
							<p>Full support of PEPPOL 3.0 and Latvian government-mandated electronic invoicing (e-rēķini).</p>
						</Link>

						<Link to="/erp-crm-integration" className="feature-card feature-card-link">
							<div className="feature-icon">
								<img src={fcERPAndCRMIntegration} />
							</div>
							<h3>ERP and CRM integration</h3>
							<p>Seamless integration with your existing ERP and CRM systems for a unified financial management experience.</p>
						</Link>

						<Link to="/incoming-invoice-processing" className="feature-card feature-card-link">
							<div className="feature-icon">
								<img src={fcIncomingInvoiceProcessing} />
							</div>
							<h3>Incoming invoice processing</h3>
							<p>Automatically receive and process your suppliers' invoices and schedule them for payment.</p>
						</Link>

						<Link to="/authentication-and-signing" className="feature-card feature-card-link">
							<div className="feature-icon">
								<img src={fcAuthenticationAndSigning} />
							</div>
							<h3>Authentication and signing</h3>
							<p>Authenticate and sign your payments with modern solutions such as Smart-ID, eParaksts and more.</p>
						</Link>

						<Link to="/scheduled-tasks" className="feature-card feature-card-link">
							<div className="feature-icon">
								<img src={fcScheduledTasks} />
							</div>
							<h3>Scheduled tasks</h3>
							<p>Automate your financial processes with scheduled tasks and recurring payments.</p>
						</Link>

						{/* <div className="feature-card">
							<div className="feature-icon"></div>
							<h3>Multi-currency support</h3>
							<p>Support of multiple currencies and exchange rates for accurate financial reporting.</p>
						</div> */}

						<div className="feature-card">
							<div className="feature-icon">
								<img src={fcMultiCompanySupport} />
							</div>
							<h3>Multi-company support</h3>
							<p>Manage multiple companies and entities from a single, unified platform.</p>
						</div>

						<Link to="/comprehensive-financial-management" className="feature-card feature-card-link">
							<div className="feature-icon">
								<img src={fcEuro} />
							</div>
							<h3>Comprehensive financial management solution</h3>
							<p>Use CashManager as a standalone service for your everyday needs, or use it in tandem with your existing system.</p>
						</Link>

						{/* <div className="feature-card">
							<div className="feature-icon">📈</div>
							<h3>Data analysis</h3>
							<p>Get instant insights into your financial performance with comprehensive dashboards.</p>
						</div>						 */}

						<Link to="/customizations" className="feature-card feature-card-link">
							<div className="feature-icon">
								<img src={fcCustomizable} />
							</div>
							<h3>Customizations</h3>
							<p>Customize CashManager to fit your specific needs and workflow. Do it yourself or let us do it for you.</p>
						</Link>

						<Link to="/user-rights-management" className="feature-card feature-card-link">
							<div className="feature-icon">
								<img src={fcUserRightsManagement} />
							</div>
							<h3>User rights management</h3>
							<p>Manage user rights and permissions to maximize security and control.</p>
						</Link>

						<Link to="/support-and-maintenance" className="feature-card feature-card-link">
							<div className="feature-icon">
								<img src={fcPhoneSupportAndMaintenance} />
							</div>
							<h3>Support and maintenance</h3>
							<p>Need help? Our team is here to assist you with any questions or issues you may have.</p>
						</Link>

						{/* <div className="feature-card">
							<div className="feature-icon">🔐</div>
							<h3>Bank-Grade Security</h3>
							<p>Your data is protected with enterprise-level security and encryption.</p>
						</div> */}

						{/* <div className="feature-card">
							<div className="feature-icon">📱</div>
							<h3>Mobile Ready</h3>
							<p>Access your financial data anywhere, anytime with our responsive design.</p>
						</div> */}

						{/* <div className="feature-card">
							<div className="feature-icon">🌍</div>
							<h3>Global Compliance</h3>
							<p>Meet international financial standards and regulatory requirements.</p>
						</div> */}
					</div>
				</div>
			</section >

			{/* CTA Section */}
			< section className="cta-section" >
				<div className="container">
					<div className="cta-content">
						<p>Join hundreds of businesses that trust CashManager for their financial operations.</p>
						<Link to="/onboarding" className="btn btn-secondary btn-large">Get started</Link>
					</div>
				</div>

			</section >

			<Copyright />
		</div >
	);
};

export default HomePage;


